/*
 * @Author: wangsaihu wangsh@xencio.com
 * @Date: 2025-03-19 16:49:15
 * @Description:
 */
import { Action, createAction, createReducer, on, props } from '@ngrx/store';
import merge from 'lodash/merge';

export interface TodoTask {
  toDoTaskList?: any; // 我的待办数据统计
}

// 初始状态
const initialState: TodoTask = {
  toDoTaskList: []
};

// 定义 Actions
export const setTodoTask = createAction('[TodoTask] Set TodoTask Info', props<TodoTask>());
export const mergeTodoTask = createAction('[TodoTask] Merge TodoTask Info', props<Partial<TodoTask>>());
export const resetTodoTask = createAction('[TodoTask] Reset Empty TodoTask');

export function todoTaskReducer(pState: TodoTask | undefined, action: Action) {
  return createReducer(
    {},
    on(setTodoTask, (state, todoTask) => ({ ...todoTask })),
    on(mergeTodoTask, (state, todoTask) => merge({}, state, todoTask)),
    on(resetTodoTask, () => initialState) //直接重置
  )(pState, action);
}
